// extracted by mini-css-extract-plugin
export default {"imgCard":"Tools_imgCard__QJeQr"};